import { Modal, Text } from '@viapeople/components'

interface DeleteConfirmDialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
	isLoading: boolean
	fingerprint: string
}

export function DeleteConfirmDialog({ isOpen, onClose, onConfirm, isLoading, fingerprint }: DeleteConfirmDialogProps) {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title='Revoke SSH Key'
			buttons={[
				{ children: 'Cancel', onClick: onClose, variant: 'secondary', disabled: isLoading },
				{
					children: isLoading ? 'Revoking...' : 'Revoke',
					onClick: onConfirm,
					variant: 'destructive',
					disabled: isLoading,
				},
			]}>
			<div className='space-y-3'>
				<Text variant='small'>
					Are you sure you want to revoke this SSH key? Any SFTP connections using this key will stop working
					immediately.
				</Text>
				<div className='bg-neutral-50 border border-neutral-200 rounded-lg p-3'>
					<Text variant='small' className='text-neutral-500'>
						Fingerprint
					</Text>
					<Text variant='small' weight='semibold' className='font-mono'>
						{fingerprint}
					</Text>
				</div>
			</div>
		</Modal>
	)
}
